import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const ActivateUserService = (userId: number) => {
  return HTTP_CLIENT.patch(`${Endpoint.users.activateUser}/${userId}`);
};

const BlockUserService = (userId: number) => {
  return HTTP_CLIENT.patch(`${Endpoint.users.blockUser}/${userId}`);
};

export { ActivateUserService, BlockUserService };
